<div class="assessment-container">
    <h2>General Appearance</h2>

    <assessment-row title="LOC" [historyMode]="true">
        <p>{{ data().loc }}</p>
    </assessment-row>

    <assessment-row title="Orientation" [historyMode]="true">
        <emr-list [list]="data().orientation" emptyText="N/A"></emr-list>
    </assessment-row>

    <assessment-row title="Lethargic" [historyMode]="true">
        <p>{{ isLethargic }}</p>
    </assessment-row>

    <assessment-row title="Inappropriate for Age" [historyMode]="true">
        <p>{{ isInappropriateForAge }}</p>
    </assessment-row>

    <assessment-row title="In Distress" [historyMode]="true">
        <p>{{ inDistress }}</p>
    </assessment-row>

    @if (patient().isObstetric()) {
    <assessment-row title="Inappropriate Baby Bonding" [historyMode]="true">
        <p>{{ data().babyBonding ? "Yes" : "No" }}</p>
    </assessment-row>

    <assessment-row title="Breast Abnormalities" [historyMode]="true">
        <p>{{ data().hasBreastAbnormalities ? "Yes" : "No" }}</p>
    </assessment-row>

    @if (data().hasBreastAbnormalities) {
    <assessment-row title="Nipple Abnormalities Notes" [historyMode]="true">
        <p>{{ data().nippleAbnormalitiesNotes }}</p>
    </assessment-row>

    <assessment-row title="Breast Abnormalities Notes" [historyMode]="true">
        <p>{{ data().breastAbnormalitiesNotes }}</p>
    </assessment-row>
    }
    }

    @if (patient().isPediatric()) {
    <assessment-row title="Support Person at Bedside" [historyMode]="true">
        <p>{{ data().supportPersonAtBedside ? "Yes" : "No" }}</p>
    </assessment-row>

    @if (data().supportPersonAtBedside) {
    <assessment-row title="Support Person Relation" [historyMode]="true">
        <p>{{ data().supportPersonType }}</p>
    </assessment-row>

    <assessment-row title="Support Person Name" [historyMode]="true">
        <p>{{ data().supportPersonName }}</p>
    </assessment-row>
    }
    }

    <assessment-row title="Other Findings" [historyMode]="true">
        <p>{{ data().otherFindings }}</p>
    </assessment-row>
</div>